export default __webpack_public_path__ + "static/Logo.9d6717647b512bc9404f388460f8bef7.png";